"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FinalCallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="finalcalltoaction" className="bg-background py-24 sm:py-32">
      <div className="mx-auto max-w-5xl px-6 lg:px-8">
        <div ref={ref} className={`relative isolate overflow-hidden bg-muted px-6 py-24 text-center shadow-2xl rounded-3xl sm:px-16 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_center,var(--color-green-accent)_0%,transparent_70%)] opacity-15" aria-hidden="true" />

          <h2 className="mx-auto max-w-2xl text-4xl font-default tracking-tight text-foreground sm:text-5xl">
            Start Your M / O Membership
          </h2>
          
          <p className="mx-auto mt-6 max-w-xl text-lg leading-8 text-foreground font-sans">
            Commit to your health. Optimize your life.
          </p>
          
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Link to="/MembershipsPage">
              <Button size="lg" className="rounded-full bg-[var(--color-green-accent)] text-white hover:bg-[var(--color-green-accent)]/90 border-none h-14 px-8 text-base shadow-lg shadow-[var(--color-green-accent)]/20">
                Join Now
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}